import {
  GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE,
  GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB,
  GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_MOBILE,
  GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_WEB,
} from '../../services/constants';
import { isServer } from '../../utils/env';

type Ad = {
  width: number;
  height: number;
  unitPath: string;
  enabled?: boolean;
  slot?: googletag.Slot;
};

// add new ad entries here
export const ADS: Record<string, Ad> = {
  [GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE]: {
    width: 320,
    height: 50,
    unitPath: '/8044662/qt_mobile_leaderboard',
  },
  [GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB]: {
    width: 728,
    height: 90,
    unitPath: '/8044662/qt_leaderboard',
  },
  [GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_MOBILE]: {
    width: 300,
    height: 250,
    unitPath: '/8044662/qt_mobile_medrect',
  },
  [GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_WEB]: {
    width: 300,
    height: 600,
    unitPath: '/8044662/qt_right_rail',
  },
};

let servicesEnabled = false;

class GAd {
  init() {
    if (isServer() || servicesEnabled) {
      return Promise.resolve();
    }

    window.googletag = window.googletag || ({ cmd: [] } as any);

    return new Promise((resolve) => {
      googletag.cmd.push(function () {
        if (servicesEnabled) {
          return resolve(true);
        }
        // https://developers.google.com/publisher-tag/guides/control-ad-loading
        googletag.pubads().disableInitialLoad();
        googletag.pubads().collapseEmptyDivs();
        googletag.enableServices();
        servicesEnabled = true;
        resolve(true);
      });
    });
  }

  async enableAd(id: string) {
    if (isServer()) {
      return;
    }

    // refresh slot
    if (ADS[id] && ADS[id].enabled && ADS[id].slot) {
      googletag.cmd.push(function () {
        googletag.display(id);
        googletag.pubads().refresh([ADS[id].slot]);
      });
      return;
    }

    ADS[id].enabled = true;

    await this.init();

    const { width, height, unitPath } = ADS[id];

    // register, refresh & cache slot
    googletag.cmd.push(function () {
      const slot = googletag
        .defineSlot(unitPath, [width, height], id)
        .addService(googletag.pubads());

      ADS[id].slot = slot;

      setTimeout(() => {
        googletag.display(id);
        googletag.pubads().refresh([slot]);
      });
    });
  }
}

export const gadService = new GAd();
